(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["google-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(section) {
      var list = section.querySelector('[data-gr-list]');
      if (!list) return;
      var arrows = section.querySelectorAll('[data-gr-dir]');
      if (!arrows.length) return;
      function update() {
        var max = list.scrollWidth - list.clientWidth - 1;
        arrows.forEach(function (a) {
          var dir = Number(a.getAttribute('data-gr-dir'));
          a.disabled = dir < 0 ? list.scrollLeft <= 0 : list.scrollLeft >= max;
        });
      }
      arrows.forEach(function (a) {
        a.addEventListener('click', function () {
          var card = list.firstElementChild;
          var step = card ? card.getBoundingClientRect().width + 16 : list.clientWidth;
          var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          list.scrollBy({ left: Number(a.getAttribute('data-gr-dir')) * step, behavior: reduce ? 'auto' : 'smooth' });
        });
      });
      list.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
    function initAll() {
      document.querySelectorAll('.google-reviews--carousel:not([data-gr-ready])').forEach(function (s) {
        s.setAttribute('data-gr-ready', '');
        init(s);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
